import i18n from "i18n";
import { useQuery } from "@tanstack/react-query";
import { ArchiveConfig } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
const useSnapshotArchivingTypes = () => useQuery({
  queryKey: ["snapshotArchivingTypes"],
  queryFn: () => defaultOnError(
    ArchiveConfig.snapshotArchivingTypes(),
    i18n.t("notifications.fetch_snapshot_archiving_types_failed", { ns: "enterprise_archive" }),
    i18n.t("notifications.fetch_snapshot_archiving_types_failed_title", { ns: "enterprise_archive" })
  ),
  staleTime: 6e4
});
export default useSnapshotArchivingTypes;
